<template>
  <div class="gift-card-promo-code-input">
    <div class="mt-lg d-flex align-items-center">
      <BaseInput
        v-model.trim="model"
        :disabled="disabled"
        class="flex-grow-1"
        input-id="promoCode"
        :label="label"/>
      <BaseButton
        :disabled="disabled || !model"
        variant="secondary"
        class="ms-md py-xs px-md"
        text="Apply"
        tracking-name="Apply Promo"
        :tracking-data="{ input: model, location }"
        @click="emit('apply', model)"/>
    </div>
    <BaseFormErrors
      v-if="errors?.length > 0"
      class="small-text m-0 px-xs"
      :errors/>
  </div>
</template>

<script setup>
import BaseInput from '@/components/global/BaseInput.vue'
import BaseFormErrors from '@/components/global/BaseFormErrors.vue'
import BaseButton from '@shared/components/ADORN/BaseButton.vue'

defineOptions({
  compatConfig: {
    COMPONENT_V_MODEL: false
  }
})

const model = defineModel({ type: String, default: '' })

defineProps({
  label: {
    type: String,
    default: 'Gift card or promo code'
  },
  location: {
    type: String,
    required: true
  },
  disabled: {
    type: Boolean,
    default: false
  },
  errors: {
    type: Array,
    default: () => []
  }
})

const emit = defineEmits(['apply'])
</script>

<style lang="scss" scoped>
:deep(.form-control) {
  height: 44px;
}
:deep(.has-float-label .form-control:placeholder-shown:not(:focus) + *) {
  top: 11px;
}
</style>
